// src/api/aiinsight.js
// API helpers for AiInsight NLQ module
// ALL calls go to the Interactive Runner (port 8001 / VITE_INTERACTIVE_BASE_URL)
// because every aiinsight route is registered on interactive/main.py, not the control plane.

import { interactiveFetch } from './index';

const BASE = '/aiinsight';

/** List all chat sessions for the current user */
export const getSessions = (token) =>
    interactiveFetch(`${BASE}/sessions`, token, { method: 'GET' });

/** Create a new chat session linked to a DataModel */
export const createSession = (token, data) =>
    interactiveFetch(`${BASE}/sessions`, token, {
        method: 'POST',
        body: JSON.stringify(data),
    });

/** Delete a session (and its queries) by ID */
export const deleteSession = (token, sessionId) =>
    interactiveFetch(`${BASE}/sessions/${sessionId}`, token, { method: 'DELETE' });

/** Rename a session title */
export const renameSession = (token, sessionId, title) =>
    interactiveFetch(`${BASE}/sessions/${sessionId}`, token, {
        method: 'PATCH',
        body: JSON.stringify({ title }),
    });

/** Fetch a session with its full query history */
export const getSessionHistory = (token, sessionId) =>
    interactiveFetch(`${BASE}/sessions/${sessionId}/history`, token, { method: 'GET' });

/** Submit a natural language query to the 3-flow AI pipeline */
export const submitQuery = (token, sessionId, userPrompt, formatOptions = {}, options = {}) =>
    interactiveFetch(`${BASE}/sessions/${sessionId}/query`, token, {
        method: 'POST',
        body: JSON.stringify({ user_prompt: userPrompt, format_options: formatOptions }),
        ...options
    });

/**
 * Fetch 5 AI-generated question suggestions based on Data Model schema.
 * @param {string} modelId - data model ID
 * @param {string|null} lastQuestion - optional last question for follow-up suggestions
 */
export const getSuggestions = (token, modelId, lastQuestion = null) => {
    const params = new URLSearchParams({ model_id: modelId });
    if (lastQuestion) params.append('last_question', lastQuestion);
    return interactiveFetch(`${BASE}/suggestions?${params.toString()}`, token, { method: 'GET' });
};
